module.exports = __webpack_public_path__ + "media/logos/officespace_favicon-f69b4649.png";